/* Store za prijavo napak: števec za značko + stanje modala.
   [PATCH napake-fe v1]
   Zvonec (obvestilaStore) ostaja nedotaknjen — to je ločen kanal. */
import { create } from 'zustand';
import { api } from '../lib/api';

interface NapakeState {
  znacka: number;
  anketa: number; // [PATCH napake-dialog-fe v4]
  mojeNeprebrano: number;
  novePrijave: number;
  jeSuperadmin: boolean;
  vidiServis: boolean; // [PATCH napake-obseg-fe v1]
  modalOdprt: boolean;
  nalozi: () => Promise<void>;
  odpri: () => void;
  zapri: () => void;
}

export const useNapakeStore = create<NapakeState>((set) => ({
  znacka: 0,
  anketa: 0, // [PATCH napake-dialog-fe v4]
  mojeNeprebrano: 0,
  novePrijave: 0,
  jeSuperadmin: false,
  vidiServis: false, // [PATCH napake-obseg-fe v1]
  modalOdprt: false,
  nalozi: async () => {
    try {
      const r = await api.get('/napake/stevec');
      const d = r.data || {};
      // [PATCH napake-dialog-fe v4] anketa se poveca ob VSAKI uspesni anketi
      // stevca (20 s / fokus / menjava rute) — NapakePage jo uporabi za tiho
      // samodejno osvezitev seznama (status, stopnja, amber, vrstni red).
      set((st) => ({
        znacka: Number(d.znacka || 0),
        mojeNeprebrano: Number(d.moje_neprebrano || 0),
        novePrijave: Number(d.nove_prijave || 0),
        jeSuperadmin: !!d.je_superadmin,
        // [PATCH napake-obseg-fe v1] ali uporabnik vidi ves racunovodski servis
        vidiServis: !!d.vidi_servis,
        anketa: st.anketa + 1,
      }));
    } catch {
      /* tiho — naslednji poll poskusi znova */
    }
  },
  odpri: () => set({ modalOdprt: true }),
  zapri: () => set({ modalOdprt: false }),
}));
